(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddDiseaseDeleteController',AddDiseaseDeleteController);

    AddDiseaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'AddDisease'];

    function AddDiseaseDeleteController($uibModalInstance, entity, AddDisease) {
        var vm = this;
        vm.addDisease = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AddDisease.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
